export const typography = {
  h1: '72px',
  h2: '40px',
  h3: '20px',
  h4: '18px',
  text: '16px',
  textSmall: '14px',
  textThin: '12px',
}

export const color = {
  primary: '#f2063f',
  secondary: '#f76921',
  grey: '#212328',
  border: '#363940',
  accepted: '#55d022',
  declined: '#ff7676',
  waitlisted: '#ff8548',
  panel: '#1a1c20',
  disabled: '#b0b6bc',
  background: '#111317',
  textDark: '#999999',
  text: '#b0b3b5',
  textLight: '#b0b6bc',
  gradient: 'linear-gradient(to right, #f2063f, #f76921)',
}
export const spacing = {
  small: '10px',
  base: '20px',
  large: '30px',
}
